{
  "generations": {
    "headTitle": "Generations",
    "titlePlatform": "Generations",
    "titleCompany": "Generations · {{name}}",
    "companyFallback": "company",
    "titleProject": "Generations · {{name}}",
    "refresh": "Refresh",
    "searchPlaceholder": "Search…",
    "periodAll": "All time",
    "period24h": "24 hours",
    "period7d": "7 days",
    "allCompanies": "All companies",
    "allProjects": "All projects",
    "allUsers": "All users",
    "activeOnly": "Active only",
    "jobKind": "Job kind",
    "jobKindReset": "All kinds",
    "creativeOnly": "No service jobs",
    "creativeOnlyHint": "Hide exports, project duplicates, agent chat and builds — keep creative work only",
    "feedCount": "Feed · {{count}}",
    "emptyFilter": "No generations match the filter",
    "projectLink": "Project “{{name}}”",
    "shotLink": "{{label}}",
    "shotLinkFallback": "Shot {{id}}",
    "canvasLink": "Canvas",
    "mediaLink": "Open result",
    "canvasModalLoadFailed": "Could not load canvas generation",
    "loadingLogs": "Loading logs…",
    "logsLoadFailed": "Could not load logs",
    "noProviderLogs": "No provider logs",
    "request": "Request",
    "response": "Response",
    "payloadNotSaved": "Payload not saved",
    "responseNotSaved": "Response not saved",
    "toggleDetails": "Job details",
    "stop": "Stop",
    "stopConfirm": "Force-stop this generation? It will be cancelled and the balance hold released. Use it for stuck jobs that never finish on their own.",
    "stopFailed": "Could not stop the generation"
  },
  "dialogs": {
    "headTitle": "Agents",
    "titlePlatform": "Agents",
    "titleCompany": "Agents · {{name}}",
    "companyFallback": "company",
    "searchPlaceholder": "Search",
    "searchHint": "Search dialogs",
    "searchClear": "Clear search",
    "periodAll": "All time",
    "period24h": "24 hours",
    "period7d": "7 days",
    "period30d": "30 days",
    "period90d": "90 days",
    "periodApply": "Apply",
    "allCompanies": "All companies",
    "allProjects": "All projects",
    "allUsers": "All users",
    "allModes": "All types",
    "empty": "No dialogs match the filter",
    "selectPrompt": "Select a dialog",
    "selectHint": "Open a dialog from the list on the left to read the conversation.",
    "open": "Open",
    "backToList": "Back to list",
    "loadMore": "Show more",
    "pin": "Pin",
    "unpin": "Unpin",
    "resizeList": "Dialog list width",
    "resizePanes": "Pane divider",
    "closePane": "Close pane",
    "shotTitle": "Shot {{label}}",
    "filters": {
      "title": "Filters",
      "active": "Filters selected",
      "period": "Period",
      "mode": "Agent type",
      "company": "Company",
      "project": "Project",
      "user": "User",
      "search": "Search",
      "reset": "Reset"
    },
    "modes": {
      "shots_assistant": "Storyboard",
      "characters_assistant": "Characters",
      "locations_assistant": "Locations",
      "props_assistant": "Props",
      "canvas_assistant": "Canvas",
      "flow_assistant": "Flow",
      "skills_assistant": "Skills",
      "skills_discussion_assistant": "Skills: discuss",
      "skills_editor_assistant": "Skills: edit",
      "script_assistant": "Script",
      "projects_assistant": "Projects",
      "tasks_assistant": "Tasks",
      "scene3d_assistant": "3D scenes"
    },
    "messages": "Messages",
    "mode": "Mode",
    "context": "Context",
    "user": "User",
    "project": "Project",
    "company": "Company",
    "lastMessage": "Last message",
    "messageCount": "{{count}} msgs",
    "roleUser": "Director",
    "roleAssistant": "Agent",
    "roleTool": "Tool",
    "roleSystem": "System",
    "toolCalls": "Tool calls",
    "pendingAction": "Pending confirmation",
    "prevPage": "Previous",
    "nextPage": "More",
    "page": "Page {{page}}",
    "contextTypes": {
      "project": "Project",
      "shot": "Shot",
      "character": "Character",
      "location": "Location",
      "prop": "Prop",
      "canvas": "Canvas",
      "company": "Company"
    }
  }
}
